<div class="modal-header">
  <h4 class="modal-title pull-left">{{ 'popups.modalTitles.' + headerTitle | translate}}</h4>
  <button type="button" class="close pull-right" aria-label="Close" (click)="closeModal()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>


<div class="modal-body">
  <div class="text-center">
    <h2>{{ 'popups.modalText.' + modalMessage | translate}}</h2>

    <div class="d-flex align-items-center mt-3">
      <button type="submit" (click)="onSubmit()"
              class="btn btn-primary btn-md mr-3">{{'common.confirm' | translate}}</button>
      <button type="submit" (click)="closeModal()"
              class="btn btn-primary btn-md ml-auto">{{'common.cancel' | translate}}</button>
    </div>
  </div>
</div>
